
<sm-title-bar [headerCustomTemplate]="addButton" pageTitle="Product list" [backWithParams]="true">
    <ng-template #addButton>
      <div class="d-flex search-field">
      
  
        <!-- <button mat-button aria-label="option menu" [matMenuTriggerFor]="menu" color="accent" >
          <mat-icon class="material-icons-round try" [inline]="true">add_circle</mat-icon>
        </button> -->
  
        <div class="create_btn_sd" *ngIf="isOwner" aria-label="option menu" [matMenuTriggerFor]="menu">
          <button mat-button color="accent">
              <mat-icon>add</mat-icon> 
          Add product
          </button>
      </div>
  
        <mat-menu #menu="matMenu">
          <button  mat-menu-item (click)="onCreateNewService()">
            <mat-icon class="material-icons-outlined">add</mat-icon>
            <span>Add product manually</span>
          </button>
          <button  mat-menu-item (click)="onCreateProductFromInventory()">
            <mat-icon class="material-icons-outlined"> fact_check</mat-icon>
            <span>Add product from inventory</span>
          </button>
         
        </mat-menu>
      </div>
    </ng-template>
  </sm-title-bar>
  <!-- <div class="chip_cont">
    <mat-chip-list aria-label="Fish selection" class="mb-3">
      <mat-chip
        style="height: auto"
        [ngClass]="{ selected: selectedValue == '0' }"
        (click)="changeChip('0')"
        >{{ 'services.home_service' | translate }}
      </mat-chip>
    </mat-chip-list>
  
    <mat-chip-list aria-label="Fish selection" class="mb-3">
      <mat-chip
        style="height: auto"
        [ngClass]="{ selected: selectedValue == '1' }"
        (click)="changeChip('1')"
        >{{ 'services.shop_service' | translate }}
      </mat-chip>
    </mat-chip-list>
  </div> -->
  <div class="search_sect">
  <mat-form-field appearance="outline" class="me-2">
    <mat-label>{{ 'services.label' | translate }}</mat-label>
    <input
    [formControl]="searchString"
    (keyup)="searchServiceData()"
      matInput
      placeholder="{{ 'services.placeholder' | translate }}"
      
    />
    <button
      mat-button
      *ngIf="!searchString.value"
      matSuffix
      mat-icon-button
      aria-label="Clear"
    >
      <mat-icon>search</mat-icon>
    </button>
    <button
    mat-button
    *ngIf="searchString.value"
    matSuffix
    mat-icon-button
    aria-label="Clear"
    (click)="reset()"
  >
    <mat-icon>close</mat-icon>
  </button>
  </mat-form-field>
  
  </div>
  <!-- 
  
  <mat-card *ngIf="!loader">
    <mat-card-header class="justify-content-between align-items-center mb-3">
      
       </mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="productList" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"
         [showPagination]="false" [showImageColumn]="true"  [imageTemplate]="image" [itemsPerPage]="5">
      </sm-data-table>
    </div>
  </mat-card> -->
  <div class="service_card_sedf">
    <div class="row">
        <div class="col-sm-3 servicend" *ngFor="let item of productList">
            <div class="serv_sect">
        <mat-card class="service-card">
          <mat-card-header class="hy_secf">
            <div mat-card-avatar class="header-avatar">
                   <div class="red_dot_ser" *ngIf="item.status == 7"></div>
                   <div class="green_dot_ser" *ngIf="item.status == 1"></div>
                <img [src]="item.thumb_image_url" onerror="this.src='../../../../assets/images/photo.png'" alt="Service image">
            </div>
            <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options" *ngIf="isOwner">
                <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu2="matMenu">
                <button mat-menu-item (click)="onEditProduct(item)">
                    <mat-icon class="material-icons-outlined">edit</mat-icon>
                    <span>Edit</span>
                </button>
                <button mat-menu-item (click)="changeStatus(item,1)" *ngIf="item.status == 7">
                  <mat-icon class="material-icons-outlined">check_circle</mat-icon>
                  <span>Activate</span>
              </button>
              <button mat-menu-item (click)="changeStatus(item,7)" *ngIf="item.status == 1">
                  <mat-icon class="material-icons-outlined">unpublished</mat-icon>
                  <span>Deactivate</span>
              </button>
                <button mat-menu-item (click)="deleteService(item)">
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                    <span>Delete</span>
                </button>
            </mat-menu>
            
        </mat-card-header>
        <mat-card-content>
            <div class="header_ftgt">
                <!-- <mat-card-title>{{item.product_name}}</mat-card-title> -->
                    <mat-card-title
                        matTooltip="{{ item.product_name }}"
                        matTooltipPosition="above"
                        class="mat-card-title ellipsis-2">
                        {{ item.product_name }}
                        </mat-card-title>
                <mat-card-subtitle>{{item.service_type}}</mat-card-subtitle>
                <p>{{item.qty_info}} {{item.selling_unit}}</p>
            </div>
            <div class="rates" *ngIf="!item.discount_status || item.discount_status == null || item.discount_status == 0">
                <div class="rate-item" *ngIf="item.home_price != '-'">
                    <span class="rate-label">Home Rate</span>
                    
                    <span class="rate-value" *ngIf="item.home_discounted_price == '-'">
                        <span class="discounted-rate">{{item.currency_symbol ? item.currency_symbol : ''}}{{item.home_price.toFixed(2)}}</span>
                    </span>
                </div>
                <div class="rate-item" *ngIf="item.shop_price != '-'">
                    <span class="rate-label">Shop Rate</span>
                    
                    <span class="rate-value" *ngIf="item.shop_discounted_price == '-'">
                        <span class="discounted-rate">{{item.currency_symbol ? item.currency_symbol : ''}}{{item.shop_price.toFixed(2)}}</span>
                    </span>
                </div>
                <div class="rate-item" *ngIf="item.virtual_price != '-'">
                  <span class="rate-label">Virtual Rate</span>
                 
                  <span class="rate-value" *ngIf="item.virtual_discounted_price == '-'">
                      <span class="discounted-rate">{{item.currency_symbol ? item.currency_symbol : ''}}{{item.virtual_price.toFixed(2)}}</span>
                  </span>
              </div>
                
            </div>
           <div class="" *ngIf="item.discount_status && item.discount_status != null && item.discount_status != 'null' && item.discount_status == 1">
                <div class="rate-item" *ngIf="item.home_price != '-'">
                    <span class="rate-label">Home Rate</span>
                    <span class="rate-value" *ngIf="item.home_discounted_price != '-'">
                        <span class="original-rate">{{item.currency_symbol ? item.currency_symbol : ''}}{{item.home_price.toFixed(2)}}</span>
                        <span class="discounted-rate">{{item.currency_symbol ? item.currency_symbol : ''}}{{item.home_discounted_price.toFixed(2)}}</span>
                    </span>
                    <span class="rate-value" *ngIf="item.home_discounted_price == '-'">
                        <span class="original-rate">{{item.currency_symbol ? item.currency_symbol : ''}}{{item.home_price.toFixed(2)}}</span>
                        <span class="discounted-rate">{{item.currency_symbol ? item.currency_symbol : ''}}0.00</span>
                    </span>
                   
                </div>
                <div class="rate-item" *ngIf="item.shop_price != '-'">
                    <span class="rate-label">Shop Rate</span>
                    <span class="rate-value" *ngIf="item.shop_discounted_price != '-'">
                        <span class="original-rate">{{item.currency_symbol ? item.currency_symbol : ''}}{{item.shop_price.toFixed(2)}}</span>
                        <span class="discounted-rate">{{item.currency_symbol ? item.currency_symbol : ''}}{{item.shop_discounted_price.toFixed(2)}}</span>
                    </span>
                    <span class="rate-value" *ngIf="item.shop_discounted_price == '-'">
                        <span class="original-rate">{{item.currency_symbol ? item.currency_symbol : ''}}{{item.shop_price.toFixed(2)}}</span>
                        <span class="discounted-rate">{{item.currency_symbol ? item.currency_symbol : ''}}0.00</span>
                    </span>
                   
                </div>
                <div class="rate-item" *ngIf="item.virtual_price != '-'">
                  <span class="rate-label">Virtual Rate</span>
                  <span class="rate-value" *ngIf="item.virtual_discounted_price != '-'">
                      <span class="original-rate">{{item.currency_symbol ? item.currency_symbol : ''}}{{item.virtual_price.toFixed(2)}}</span>
                      <span class="discounted-rate">{{item.currency_symbol ? item.currency_symbol : ''}}{{item.virtual_discounted_price.toFixed(2)}}</span>
                  </span>
                  <span class="rate-value" *ngIf="item.virtual_discounted_price == '-'">
                      <span class="original-rate">{{item.currency_symbol ? item.currency_symbol : ''}}{{item.virtual_price.toFixed(2)}}</span>
                      <span class="discounted-rate">{{item.currency_symbol ? item.currency_symbol : ''}}0.00</span>
                  </span>
             
              </div>
                
            </div>
           <p class="description" [matTooltip]="item.product_desc">
                {{item.product_desc | ellipsify: 80}}
            </p>
        </mat-card-content>
  
    </mat-card>
  </div>
  </div>

  
  
  
  <!--  -->
  
  
  
  
  </div>
  </div>
  <div class="placeholder_started" *ngIf="productList.length == 0 && !loader">
    <div class="row">

      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card>
              <div class="upload_sectio">
             <div class="icm_img">
                <img src="./assets/images/add-service.png">
             </div>
             <mat-card-title>No product to show</mat-card-title>
             <mat-card-content>All the products getting sold by your business will appear here. Start adding one now.
            </mat-card-content>
             <div class="watch_vc_btn">
              <button mat-button aria-label="option menu" [matMenuTriggerFor]="menu" color="accent" *ngIf="isOwner">
                <mat-icon>add</mat-icon> 
            Add product
            </button>
            <mat-menu #menu="matMenu">
              <button  mat-menu-item (click)="onCreateNewService()">
                <mat-icon class="material-icons-outlined">add</mat-icon>
                <span>Add product manually</span>
              </button>
              <button  mat-menu-item (click)="onCreateProductFromInventory()">
                <mat-icon class="material-icons-outlined"> fact_check</mat-icon>
                <span>Add product from inventory</span>
              </button>
             
            </mat-menu>

             </div>
             </div>
          </mat-card>
       </div>
      </div>

      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card>
              <div class="upload_sectio">
             <div class="icm_img">
                <img src="./assets/images/add-product-1.png">
             </div>
             <mat-card-title>How to add product?</mat-card-title>
             <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')">help document</span> on creating products against a business. You can check this video as well.
            </mat-card-content>
             <div class="watch_vc_btn">
                <button mat-stroked-button color="primary" (click)="openvideo()">
                   <mat-icon>play_arrow</mat-icon>
                   Watch video
                </button>
             </div>
             </div>
          </mat-card>
       </div>
      </div>
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card>
              <div class="upload_sectio">
             <div class="icm_img">
                <img src="./assets/images/helpsupport.png">
             </div>
             <mat-card-title>Having any issue?</mat-card-title>
             <mat-card-content>For any difficulties in adding service or if there's any issue while adding service, contact our support team.
            </mat-card-content>
             <div class="watch_vc_btn">
                <button mat-stroked-button color="primary" (click)="opencontact()">
                   <mat-icon>support_agent</mat-icon>
                   Contact support
                </button>
             </div>
             </div>
          </mat-card>
       </div>
      </div>
    </div>
  
  </div>
  
  <!-- <mat-paginator
  *ngIf="!loader && productList.length > 0"
    class="mt-4"
    [length]="datalength"
    [pageSize]="25"
    (page)="onPageChange($event)"
  >
  </mat-paginator> -->
  
  